@import (reference) '../../../../../constants/spacing.module.less';

.manage-mfa-button {
  width: fit-content;
}

.type-column {
  justify-content: flex-start;
}

.centered {
  align-items: center;
  justify-content: center;
}

.icon {
  display: flex;
  .centered();

  width: 16px;
}

.action-button-column {
  justify-content: center;
}

.mfa-enabled-pill {
  margin-left: @space-8;
}

.green-status-dot {
  height: 6px;
  color: var(--green-600);
  margin-right: @space-4;
}
